import React from "react";

import TCPStepsSearch from "../TCPStepsSearch";
import GMCappersSearch from "../GMCappersSearch";
import HeliosPassesSearch from "../HeliosPassesSearch";
import HeliosFailedSearch from "../HeliosFailedSearch";
import WithdrawalsSearch from "../WithdrawalsSearch";
import HeliosAndAppiusLiveSearch from "../HeliosAndAppiusLiveSearch";
import HeliosLiveSIMTraderInformationFormSearch from "../HeliosLiveSIMTraderInformationFormSearch";
import { TableWrapper } from "../../styledComponents";

const FundedAccountQuickSearch: React.FC = () => (
  <div>
    <TableWrapper>
      <HeliosPassesSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <WithdrawalsSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <HeliosFailedSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <TCPStepsSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <GMCappersSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <HeliosLiveSIMTraderInformationFormSearch />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <HeliosAndAppiusLiveSearch />
    </TableWrapper>
  </div>
);

export default FundedAccountQuickSearch;
